import { VscChevronDown } from '@react-icons/all-files/vsc/VscChevronDown'
import { VscChevronRight } from '@react-icons/all-files/vsc/VscChevronRight'
import TreeView, { flattenTree, NodeId } from 'react-accessible-treeview'
import { IFlatMetadata } from 'react-accessible-treeview/dist/TreeView/utils'
import { cm } from '~/utils/utils'

export interface ITreeNode<M extends IFlatMetadata> {
  id?: NodeId
  name: string
  isBranch?: boolean
  children?: ITreeNode<M>[]
  metadata?: M
}

export function ControlledExpandedNode({ node }: { node: ITreeNode<IFlatMetadata> | null }) {
  return node ? (
    <div className='checkbox'>
      <TreeView
        data={flattenTree(node)}
        defaultExpandedIds={[1]}
        className=''
        nodeRenderer={({
          element,
          isBranch,
          isExpanded,
          isDisabled,
          getNodeProps,
          level,
          handleExpand
        }) => {
          const color = Math.max(8 - level, 5)
          return (
            <div
              {...getNodeProps({ onClick: handleExpand })}
              className={`flex items-start select-none cursor-pointer text-default-${color}00`}
              style={{
                marginLeft: 10 * (level - 1),
                opacity: isDisabled ? 0.5 : 1
              }}
            >
              {isBranch && <ArrowIcon isOpen={isExpanded} />}
              <span
                className='name break-words text-wrap flex-1 max-w-full pr-2 text-sm leading-relaxed'
                title={element.name}
              >
                {element.name}
              </span>
            </div>
          )
        }}
      />
    </div>
  ) : (
    <div className='ml-1 text-default-500'>No review history yet</div>
  )
}

interface ArrowIconProps {
  isOpen: boolean
  className?: string
}

const ArrowIcon = ({ isOpen, className }: ArrowIconProps) => {
  const baseClass = 'arrow'
  const classes = cm(baseClass, className, 'mr-1')
  return isOpen ? <VscChevronDown className={classes} /> : <VscChevronRight className={classes} />
}
